<nrk-window #globalWindow>
  <nrk-header>Unit Selection</nrk-header>
  <nrk-content *ngIf="selectedRow && productPrice.finishedProduct">
    <ngx-unit-converter
      [finishedProduct]="productPrice.finishedProduct"
      [price]="selectedRow"
      (priceChange)="fpPriceChanged()"
      >
    </ngx-unit-converter>
  </nrk-content>
</nrk-window>

<ng-sidebar-container [ngClass]="issuer === 2 ? 'nrk-nrka-background' : 'nrk-nrkg-background'">
  <div ng-sidebar-content>
    <ngx-page-container>
      <h1>Price Matrix</h1>
      <hr>
      <div *ngIf="displayMode == 'finished-product'">
        <h3 *ngIf="productPrice.finishedProduct"><span class="fp-link" (click)="navigateToFinishedProduct(mongoId(productPrice.finishedProduct))">&nbsp;&#11016;&nbsp;</span>{{getProductName()}}</h3>
        <div class="row">
          <div class="col-2"><label>Select Finished Product</label></div>
          <div class="col-4">
            <div class="form-group">
              <!-- <ngx-form-column-select [icon]="'&nbsp;+&nbsp;'" [value]="'o'" (productSelected)="onSelectFinishedProduct($event.id)">
              </ngx-form-column-select> -->
              <ngx-document-finished-product-selector (compilationChange)="onSelectFinishedProduct($event._id)">
              </ngx-document-finished-product-selector>
            </div>
          </div>
        </div>
        <div class="pricetable">
          <h4>Selling Price</h4>
          <ngx-doc-form-filter-select title="Customer" [noBorder]="true" [noClear]="true" [options]="customerOptions" [(value)]="productPrice.sale.business" (valueChange)="businessChanged($event, 'sale')"></ngx-doc-form-filter-select>
          <ngx-form-list #formListSell
            *ngIf="getPriceColumns('sale') != null"
            [columns]="getPriceColumns('sale')"
            [(value)]="salesTable"
            [canAdd]="canAdd"
            [canEdit]="false"
            [canDelete]="canDelete"
            (editConfirm)="validate($event, 'sale')"
            (deleteConfirm)="disable($event, 'sale')"
            [confirmDelete]="true"
          >
          </ngx-form-list>
          <div class="row m-2" *ngIf="productPrice.sale.matrix && productPrice.finishedProduct && productPrice.sale.business">
            <div>
              <ngx-form-upload class="file-upload-comp" url="/api/v1/upload" accept="application/pdf" (completed)="saveDocuments(true)"
                [files]="productPrice.sale.matrix.files" [fullwidth]="true" [hideComment]="false" [hideCheckbox]="true">
              </ngx-form-upload>
            </div>
          </div>
        </div>
        <div class="pricetable">
          <h4>Buying Price</h4>
          <ngx-doc-form-filter-select title="Supplier" [noBorder]="true" [noClear]="true" [options]="supplierOptions" [(value)]="productPrice.purchase.business" (valueChange)="businessChanged($event, 'purchase')"></ngx-doc-form-filter-select>
          <ngx-form-list #formListPurchase
            *ngIf="getPriceColumns('purchase') != null"
            [columns]="getPriceColumns('purchase')"
            [(value)]="purchaseTable"
            [canAdd]="canAdd"
            [canEdit]="false"
            [canDelete]="canDelete"
            (editConfirm)="validate($event, 'purchase')"
            (deleteConfirm)="disable($event, 'purchase')"
            [confirmDelete]="true"
          >
          </ngx-form-list>
          <div class="row m-2" *ngIf="productPrice.purchase.matrix && productPrice.finishedProduct && productPrice.purchase.business">
            <div>
              <ngx-form-upload class="file-upload-comp" url="/api/v1/upload" accept="application/pdf" (completed)="saveDocuments(false)"
                [files]="productPrice.purchase.matrix.files" [fullwidth]="true" [hideComment]="false" [hideCheckbox]="true">
              </ngx-form-upload>
            </div>
          </div>
          <div class="sidebar footer text-center" *ngIf="fromWizard">
            <button *ngIf="fromWizard" class="btn btn-md btn-default" title="back to finished product" 
              (click)="navigateToFinishedProduct(mongoId(productPrice.finishedProduct))">
              <i class="ion-arrow-left-a"></i>
            </button>
            <button class="btn btn-primary btn-md" (click)="setFinishedProduct()">add finished product to line item</button>
          </div>
        </div>
      </div>

      <!-- ======================================== selling / buying price matrix ========================================= -->
      <ng-container *ngFor="let accountingPrice of accountingPrices;">
      <div *ngIf="(displayMode == 'selling' && accountingPrice == sellingPrice) || (displayMode == 'buying' && accountingPrice == buyingPrice)">
        <div>
          <h3>{{accountingPrice.title}}</h3>
        </div>
        <ngx-doc-form-filter-select title="Company" [noBorder]="true" [noClear]="true" [options]="businessOptions" [(value)]="accountingPrice.business" (valueChange)="businessChanged($event, accountingPrice)"></ngx-doc-form-filter-select>
        <ngx-form-dropdown title="Business unit" [options]="businessUnitOptions" [(value)]="accountingPrice.businessUnit" (valueChange)="businessUnitChanged($event, accountingPrice);"></ngx-form-dropdown>

        <div class = "fpm-buttons">
          <button class="btn btn-lg btn-success" (click)="win.open()">Show Table</button>
        </div>

        <div style="position:absolute">
        <nrk-window #win>
          <nrk-header><b>{{accountingPrice.title}}</b></nrk-header>
          <nrk-content>
            <div class="fpm-buttons" style="position: absolute;top:-5px;right:30px">
              <button *ngIf="!this.readOnly && accountingPrice.rowData.length" class="btn btn-primary btn-md" (click)="savePrices(accountingPrice)">Save</button>
              <button class="btn btn-info btn-md" (click)="clearFilter(accountingPrice)">Clear Filter</button>
            </div>
            <div>blue = sample, semi transparent = disabled</div>
            <form name="prices">
              <div class="fpm-table">
                <table>
                  <tr>
                    <th *ngFor="let col of matrixFields;" class="pseudo-link" (click)="onSort(col.id)">
                      {{col.name}}<span *ngIf="sort.column === col.id">&nbsp;{{sort.dir < 0 ? '▲' : '▼'}}</span></th>
                  </tr>
                  <tr id="matrixfilter">
                    <td *ngFor="let col of matrixFields;">
                      <!-- <input class="fpm-filter" [name]="'filter-'+col.id" type="text" (keydown.enter)="filter($event, col.id, accountingPrice)"/> -->
                      <!-- <input class="fpm-filter" [name]="'filter-'+col.id" type="text" (keyup)="filter($event, col.id, accountingPrice)"/> -->
                      <input class="fpm-filter" [name]="'filter-'+col.id" type="text" (input)="filter($event, col.id, accountingPrice)"/>
                    </td>
                  </tr>
                  <ng-container *ngIf="currentRows.length">
                  <tr *ngFor="let row of currentRows; index as idx">
                    <td *ngFor="let col of matrixFields;"
                      [ngStyle]="col.style"
                      [style.text-align]="col.num ? 'right' : undefined"
                      [style.opacity]="row.disabled ? 0.5 : 1"
                      [style.color]="row.sample ? 'blue' : 'black'"
                    >
                      <div *ngIf="!this.readOnly && (col.editable || col.hidden)">
                        <input class="fpm-price" [name]="'cell-'+row.id+'-'+col.id" [value]="row[col.id]" [type]="col.hidden ? 'hidden' : 'text'" (keypress)="checkKey($event)" (keyup)="checkInput($event)"/>
                        <!-- <a *ngIf="col.popup" [routerLink]="[]" style="font-size:small" (click)="onPopup()">edit</a> -->
                        <ngx-doc-form-dropdown *ngIf="col.currency" [(value)]="row[col.id]" [options]="currOptions"></ngx-doc-form-dropdown>
                        <ngx-doc-form-dropdown *ngIf="col.unit" [(value)]="row[col.id]" [options]="unitOptions"></ngx-doc-form-dropdown>
                        <ng-container *ngIf="col.files">
                          <div style="text-align:center">
                            <button *ngIf="!upload[idx]" class="nrk-button" (click)="upload[idx]=true">
                              <div *ngIf="row[col.id]?.length"><b>{{row[col.id].length}}</b></div>
                              <i style="cursor:pointer" class="ionicon ion-upload h5" title="upload document"></i>
                            </button>
                          </div>
                          <div class="fpm-files" *ngIf="upload[idx]" style="z-index:100">
                            <div>
                              <button class="nrk-button" (click)="saveFiles(row);upload[idx]=false;">&nbsp;X&nbsp;</button>
                              <ngx-form-upload class="file-upload-comp" url="/api/v1/upload" accept="application/pdf"
                                [(files)]="row[col.id]" [fullwidth]="true" [hideComment]="false" [hideCheckbox]="true">
                              </ngx-form-upload>  
                            </div>
                          </div>
                        </ng-container>
                      </div>
                      <div *ngIf="col.id === 'value' && row.finishedProduct.content.energy.rollLength"><span class="unit-converter-link" (click)="convertWin.open()">{{row[col.id]}}</span></div>
                      <nrk-window #convertWin>
                        <nrk-header>Unit Selection</nrk-header>
                        <nrk-content style="margin:1rem" *ngIf="convertWin.isVisible">
                          <ngx-unit-converter [finishedProduct]="row.finishedProduct" [price]="row.priceItem" (priceChange)="updatePrice(row, $event)"></ngx-unit-converter>
                        </nrk-content>
                      </nrk-window>
                      <!-- <div *ngIf="col.id === 'value' && row.finishedProduct.content.energy.rollLength"><span class="unit-converter-link" [nbPopover]="convertPopover" (click)="activeRow = row">{{row[col.id]}}</span></div>
                      <ng-template #convertPopover>
                        <div style="margin:1rem" *ngIf="row === activeRow">
                          <ngx-unit-converter [finishedProduct]="row.finishedProduct" [price]="row.priceItem" (priceChange)="updatePrice(row, $event)"></ngx-unit-converter>
                        </div>
                      </ng-template> -->
                      <div *ngIf="(col.id !== 'value' || !row.finishedProduct.content.energy.rollLength) && (this.readOnly || !col.editable)">{{row[col.id]}}</div>
                    </td>
                  </tr>
                  </ng-container>
                  <ng-container *ngIf="!accountingPrice.rowData.length">
                  <tr><td colspan="100">No data found</td></tr>
                  </ng-container>
                </table>
              </div>
              <div class = "fpm-buttons">
                <button *ngIf="!this.readOnly && accountingPrice.rowData.length" class="btn btn-primary btn-lg" (click)="savePrices(accountingPrice)">Save</button>
              </div>
            </form>
          </nrk-content>
        </nrk-window>
        </div>
      </div>
      </ng-container>

      <!-- ======================================== price matrix comparison ========================================= -->

      <ng-container *ngIf="displayMode === 'comparison'">

        <h3>Price matrix comparison</h3>
        <br>

        <ngx-doc-form-filter-select 
          [noBorder]="true" [separator]="'|'" [options]="baseProductOptions" [(value)]="baseProductCode" (valueChange)="baseProductChanged($event)"
          title="Select Base product">
        </ngx-doc-form-filter-select>       
        <br>
        <br>
        
        <ngx-base-product-matrix
          [baseProduct]="baseProduct"
          [finishedProducts]="finishedProductsForComparison"
          [issuer]="issuer">
        </ngx-base-product-matrix>
      </ng-container>

    </ngx-page-container>
  </div>
</ng-sidebar-container>

